<template>
  <div
    class="bg-background-neutral-secondary flex flex-col items-center rounded-2xl p-4 text-center"
    data-qa-id="citiesList.noResults"
  >
    <div
      class="bg-background-neutral-primary mb-1 flex h-[72px] w-[72px] items-center justify-center rounded-full"
    >
      <img
        src="../../assets/images/pointer.svg"
        width="48"
        height="48"
        alt=""
      />
    </div>
    <div class="mb-3">
      <h2 class="text-text-neutral-primary text-base font-semibold">
        {{ title }}
      </h2>
      <p class="text-text-neutral-tertiary text-sm">
        {{ description }}
      </p>
    </div>
    <slot name="action" />
  </div>
</template>

<script setup lang="ts">
  defineProps<{ title: string; description: string }>();
</script>
